import React, { useState } from 'react';
import { XIcon, MapPinIcon, HomeIcon, BuildingIcon, CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon, BadgeCheckIcon, LayersIcon, StarIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
import { BrochureModal } from '../BrochureModal';
import { brochurePages } from '../../data/brochurePages';
const ProjectsSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBrochureOpen, setIsBrochureOpen] = useState(false);
  const [activeImage, setActiveImage] = useState(0);
  const [activeTab, setActiveTab] = useState<'overview' | 'floorplan' | 'units'>('overview');
  const project = {
    id: 1,
    title: 'Viral Shantivan',
    category: 'Residential',
    location: 'Virar West, Maharashtra',
    status: 'Ongoing',
    rera: 'P99000078855',
    description: 'Proposed Redevelopment of Viral & Shantivan Society, Virar West. A premium residential complex offering modern 1 BHK and 2 BHK apartments with retail spaces on the ground floor.',
    brochure: {
      label: 'Viral Shantivan Brochure',
      note: `${brochurePages.length} pages · Highlights, layouts, amenities & specifications`
    },
    images: [{
      url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qsdDED6hcK3bpaqpZuX5sy/WhatsApp_Image_2025-03-20_at_10.25.59_PM.jpg',
      label: 'Exterior View (Night)'
    }, {
      url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6vKDemLDxmQLyjfaZxqx8k/WhatsApp_Image_2025-03-20_at_10.26.00_PM.jpg',
      label: 'Exterior View (Day)'
    }, {
      url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iKY8MrH4rB6iDMRTiYMMsA/WhatsApp_Image_2025-03-15_at_7.40.52_PM.jpg',
      label: '3D Floor Plan'
    }, {
      url: 'https://cdn.magicpatterns.com/uploads/nRoW81Yz4fSueuXAws29hU/Screenshot_2026-03-01_102437.png',
      label: 'Typical Floor Plan'
    }],
    wings: [{
      name: 'A Wing',
      units: [{
        rno: '101',
        area: 427,
        type: '1 BHK'
      }, {
        rno: '102',
        area: 618,
        type: '2 BHK'
      }, {
        rno: '103',
        area: 430,
        type: '1 BHK'
      }, {
        rno: '104',
        area: 504,
        type: '2 BHK'
      }, {
        rno: '105',
        area: 462,
        type: '1 BHK'
      }]
    }, {
      name: 'B Wing',
      units: [{
        rno: '101',
        area: 440,
        type: '1 BHK'
      }, {
        rno: '102',
        area: 513,
        type: '2 BHK'
      }, {
        rno: '103',
        area: 434,
        type: '1 BHK'
      }, {
        rno: '104',
        area: 429,
        type: '1 BHK'
      }]
    }, {
      name: 'C Wing',
      units: [{
        rno: '101',
        area: 487,
        type: '2 BHK'
      }, {
        rno: '102',
        area: 644,
        type: '2 BHK'
      }, {
        rno: '103',
        area: 422,
        type: '1 BHK'
      }]
    }],
    amenities: ['Elegant Entrance Lobby', "App-Based Visitor's Management & Society Operations", 'Terrace – Bistro, Roof Top Lounge Sitting Area & Senior Citizen Corner', 'CCTV Surveillance & Intercom', 'Designated Parking Space for Vehicles', 'D-G Set for Lifts & Common Areas', 'Various Flat Configuration Options', 'Driver Room', 'Society Office', 'Telecom Room', 'Solar Panels to Reduce Electricity Bill of Society', 'Charging Stations for E-Vehicles', 'Gas Pipeline', 'Modular Kitchen with Vitrified Tiles']
  };
  const prevImage = () => setActiveImage(prev => prev === 0 ? project.images.length - 1 : prev - 1);
  const nextImage = () => setActiveImage(prev => prev === project.images.length - 1 ? 0 : prev + 1);
  return <section id="projects" className="py-20 bg-gray-50" data-id="element-375" data-mp="27gx51jilm1hu">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-376" data-mp="27jjc7i1kuezj">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-377" data-mp="22k6pqyemb9xh">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-378" data-mp="305uj1afs1c4s">
            Our Projects
          </h2>
          <div className="w-20 h-1 bg-blue-800 mx-auto mb-6" data-id="element-379" data-mp="2v6rgbwn9rhzz"></div>
          <p className="max-w-3xl mx-auto text-gray-600 text-lg" data-id="element-380" data-mp="2qgb0y6zw1maz">
            Discover our portfolio of premium residential developments across
            Maharashtra.
          </p>
        </div>

        {/* Project Card */}
        <div className="max-w-4xl mx-auto" data-id="element-381" data-mp="3iwvj61smvdpx">
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg group" data-id="element-382" data-mp="3ixwvsapas89r">
            {/* Image */}
            <div className="relative h-80 overflow-hidden" data-id="element-383" data-mp="3e3sn9n0dvs6k">
              <img src={project.images[0].url} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-384" data-mp="3li3753g8r10c" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-385" data-mp="3vdwkgp1sayj6" />
              {/* Status Badge */}
              <div className="absolute top-4 right-4 bg-blue-800 text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5" data-id="element-386" data-mp="8b1j5y454e8r">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse inline-block" data-id="element-387" data-mp="d7rz8lfy39u6"></span>
                {project.status}
              </div>
              {/* RERA Badge */}
              <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-gray-800 text-xs font-semibold px-3 py-1.5 rounded-full flex items-center gap-1.5" data-id="element-388" data-mp="myv0pocsdqtz">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-blue-800" data-id="element-389" data-mp="vzb2mtdvspwq" />
                MahaRERA: {project.rera}
              </div>
              {/* Bottom overlay info */}
              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-390" data-mp="2o1vtswl4fmge">
                <h3 className="text-2xl font-bold text-white mb-1" data-id="element-391" data-mp="2nzj39v1as3rq">
                  {project.title}
                </h3>
                <div className="flex items-center text-white/90 text-sm" data-id="element-392" data-mp="2x2bw42q4onjo">
                  <MapPinIcon className="h-4 w-4 mr-1.5 flex-shrink-0" data-id="element-393" data-mp="2x07giniva03k" />
                  {project.location}
                </div>
              </div>
            </div>

            {/* Card Body */}
            <div className="p-6 md:p-8" data-id="element-394" data-mp="36u7ulew4mfof">
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-395" data-mp="3ksej44f6r3bf">
                {project.description}
              </p>

              {/* Key Stats */}
              <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-396" data-mp="3gr2ua144ym4a">
                <div className="bg-blue-50 rounded-xl p-4 text-center" data-id="element-397" data-mp="1qewt8arb5ud8">
                  <LayersIcon className="h-6 w-6 text-blue-800 mx-auto mb-2" data-id="element-398" data-mp="1mcjptt01a8jm" />
                  <p className="text-2xl font-bold text-gray-900" data-id="element-399" data-mp="1mempz5uwhi22">3</p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-400" data-mp="1c8v6ccnz6t75">Wings</p>
                </div>
                <div className="bg-blue-50 rounded-xl p-4 text-center" data-id="element-401" data-mp="1g9f33f4mzusr">
                  <HomeIcon className="h-6 w-6 text-blue-800 mx-auto mb-2" data-id="element-402" data-mp="12jblj1gpcp9n" />
                  <p className="text-2xl font-bold text-gray-900" data-id="element-403" data-mp="17hd4lme4ool4">1 & 2</p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-404" data-mp="17fim0eqbx8k7">BHK Types</p>
                </div>
                <div className="bg-blue-50 rounded-xl p-4 text-center" data-id="element-405" data-mp="smgrovvdjd1p">
                  <BuildingIcon className="h-6 w-6 text-blue-800 mx-auto mb-2" data-id="element-406" data-mp="xk8jzqzxl16f" />
                  <p className="text-2xl font-bold text-gray-900" data-id="element-407" data-mp="jkpllpwx947b">G+7</p>
                  <p className="text-xs text-gray-500 mt-0.5" data-id="element-408" data-mp="oihasc66mc7t">Floors</p>
                </div>
              </div>

              {/* Highlights */}
              <div className="grid grid-cols-2 gap-2 mb-6" data-id="element-409" data-mp="2dy8egmg0byma">
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-410" data-mp="2ixbiq4o5y0t7">
                  <CheckCircleIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-411" data-mp="3rh7koohsfn5n" />
                  Premium 1 & 2 BHK Apartments
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-412" data-mp="3minziqb0qfec">
                  <CheckCircleIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-413" data-mp="3hqcoaratv76h" />
                  Ground Floor Retail Spaces
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-414" data-mp="3dnztgxxmctoh">
                  <CheckCircleIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-415" data-mp="38s116z966ris" />
                  Rooftop Amenities
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-416" data-mp="2ysa89209ckkt">
                  <CheckCircleIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-417" data-mp="2uqyc0dmvp13n" />
                  Modern Architecture
                </div>
              </div>

              {/* CTA */}
              <div className="flex flex-col sm:flex-row gap-3" data-id="element-418" data-mp="wyuehw8viplm">
                <button onClick={() => {
                setIsModalOpen(true);
                setActiveTab('overview');
                setActiveImage(0);
              }} className="flex-1 py-3 bg-blue-800 hover:bg-blue-900 text-white rounded-lg font-medium transition-all text-sm tracking-wide" data-id="element-419" data-mp="t0wl0h82lhcf">
                  View Full Project Details
                </button>
                <button onClick={() => setIsBrochureOpen(true)} className="flex-1 inline-flex items-center justify-center gap-2 py-3 border border-blue-800 text-blue-800 hover:bg-blue-50 rounded-lg font-medium transition-all text-sm tracking-wide" data-id="element-420" data-mp="2oqfy02q3z8wl">
                  <FileTextIcon className="h-4 w-4" data-id="element-421" data-mp="211dgqvzdzi2m" />
                  View Brochure
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-16 rounded-xl overflow-hidden shadow-sm h-96 bg-gray-200" data-id="element-422" data-mp="3cgjyw2bwwujw">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d665.0651092383707!2d72.81108228653369!3d19.447960388683413!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7a9823fc39e99%3A0x4f12ef2d8266191d!2sViral%20Apartment!5e0!3m2!1sen!2sin!4v1742555659108!5m2!1sen!2sin" className="w-full h-full" style={{
          border: 0
        }} allowFullScreen loading="lazy" title="Viral Shantivan Location" data-id="element-423" data-mp="3hfdeq1eo8xn8" />
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={e => {
      if (e.target === e.currentTarget) setIsModalOpen(false);
    }} data-id="element-424" data-mp="30f7ytdz4j51j">
          <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto shadow-2xl" data-id="element-425" data-mp="ko3ld3pes8yv">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white z-10 flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-426" data-mp="oo3z0m4oog4v">
              <div data-id="element-427" data-mp="299k79tyt582a">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-428" data-mp="255ul1b5lv2kf">
                  {project.title}
                </h2>
                <div className="flex items-center text-gray-500 text-sm mt-0.5" data-id="element-429" data-mp="20ema2aomn955">
                  <MapPinIcon className="h-3.5 w-3.5 mr-1" data-id="element-430" data-mp="1vg2nq964fvc9" />
                  {project.location}
                </div>
              </div>
              <button onClick={() => setIsModalOpen(false)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Close modal" data-id="element-431" data-mp="1qi13hkwylpz7">
                <XIcon className="h-5 w-5 text-gray-600" data-id="element-432" data-mp="1hgtjm7v6wron" />
              </button>
            </div>

            {/* Image Gallery */}
            <div className="relative bg-gray-900 h-72 md:h-96" data-id="element-433" data-mp="1cjjn689dvfrb">
              <img src={project.images[activeImage].url} alt={project.images[activeImage].label} className="w-full h-full object-cover opacity-95" data-id="element-434" data-mp="3btsujnomkxpl" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-435" data-mp="3pyjraorfqpn1" />
              {/* Image label */}
              <div className="absolute bottom-4 left-4 bg-black/50 backdrop-blur-sm text-white text-xs px-3 py-1.5 rounded-full" data-id="element-436" data-mp="3gz52dtqx2n4n">
                {project.images[activeImage].label}
              </div>
              {/* Nav arrows */}
              <button onClick={prevImage} className="absolute left-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 hover:bg-white/40 text-white rounded-full transition-all" data-id="element-437" data-mp="djhg92u8pc9d">
                <ChevronLeftIcon className="h-5 w-5" data-id="element-438" data-mp="3jgvdcgq2o32" />
              </button>
              <button onClick={nextImage} className="absolute right-3 top-1/2 -translate-y-1/2 p-2 bg-white/20 hover:bg-white/40 text-white rounded-full transition-all" data-id="element-439" data-mp="8ijyush20m8x">
                <ChevronRightIcon className="h-5 w-5" data-id="element-440" data-mp="2taddpccjcmwm" />
              </button>
              {/* Status badge */}
              <div className="absolute top-4 right-4 bg-blue-800 text-white text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1.5" data-id="element-441" data-mp="2lo86dus6lzj4">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse inline-block" data-id="element-442" data-mp="2uqhjmseu4707"></span>
                {project.status}
              </div>
            </div>

            {/* Thumbnail strip */}
            <div className="flex gap-2 px-6 py-3 bg-gray-50 border-b border-gray-100 overflow-x-auto" data-id="element-443" data-mp="221ajjozqf9cu">
              {project.images.map((img, idx) => <button key={idx} onClick={() => setActiveImage(idx)} className={`flex-shrink-0 w-16 h-12 rounded-lg overflow-hidden border-2 transition-all ${activeImage === idx ? 'border-blue-800 opacity-100' : 'border-transparent opacity-60 hover:opacity-80'}`} data-id="element-444" data-mp="1xydy7qit4z57" data-mpi={idx}>
                  <img src={img.url} alt={img.label} className="w-full h-full object-cover" data-id="element-445" data-mp="1ed0ywqe98rna" />
                </button>)}
            </div>

            {/* Tabs */}
            <div className="flex border-b border-gray-100 px-6" data-id="element-446" data-mp="1ww70zi7grxw7">
              <button onClick={() => setActiveTab('overview')} className={`py-3 px-4 text-sm font-medium border-b-2 transition-colors ${activeTab === 'overview' ? 'border-blue-800 text-blue-800' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-447" data-mp="21wmafyomkl8w">
                Overview
              </button>
              <button onClick={() => setActiveTab('floorplan')} className={`py-3 px-4 text-sm font-medium border-b-2 transition-colors ${activeTab === 'floorplan' ? 'border-blue-800 text-blue-800' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-448" data-mp="2knvx79nep6if">
                Floor Plan
              </button>
              <button onClick={() => setActiveTab('units')} className={`py-3 px-4 text-sm font-medium border-b-2 transition-colors ${activeTab === 'units' ? 'border-blue-800 text-blue-800' : 'border-transparent text-gray-500 hover:text-gray-700'}`} data-id="element-449" data-mp="v9qvq561tcox">
                Unit Configuration
              </button>
            </div>

            {/* Tab Content */}
            <div className="p-6" data-id="element-450" data-mp="2utdq2d1gpk6l">
              {/* Overview Tab */}
              {activeTab === 'overview' && <div data-id="element-451" data-mp="3rfz39j7d99r8">
                  <div className="flex flex-wrap gap-3 mb-6" data-id="element-452" data-mp="3nghvuk8dq2jf">
                    <span className="inline-flex items-center gap-1.5 bg-blue-50 text-blue-800 text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-453" data-mp="3nh9hp3c6clwi">
                      <BadgeCheckIcon className="h-3.5 w-3.5" data-id="element-454" data-mp="3dik7zxufm7rc" />
                      MahaRERA: {project.rera}
                    </span>
                    <span className="inline-flex items-center gap-1.5 bg-gray-100 text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-455" data-mp="2731623sxzwzn">
                      <HomeIcon className="h-3.5 w-3.5" data-id="element-456" data-mp="23karmdhmlkh0" />
                      {project.category}
                    </span>
                    <span className="inline-flex items-center gap-1.5 bg-gray-100 text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-457" data-mp="28jx2ig9zeomn">
                      <MapPinIcon className="h-3.5 w-3.5" data-id="element-458" data-mp="1ujcn7u39zaxw" />
                      {project.location}
                    </span>
                  </div>

                  <p className="text-gray-600 leading-relaxed mb-8" data-id="element-459" data-mp="1ktawsvng9gft">
                    {project.description}
                  </p>

                  {/* Brochure Download */}
                  <button onClick={() => setIsBrochureOpen(true)} className="w-full text-left flex items-center gap-4 mb-8 p-4 rounded-xl border border-blue-100 bg-blue-50 hover:bg-blue-100 transition-colors group" data-id="element-460" data-mp="1bt4pxsm9bepm">
                    <div className="p-3 bg-white rounded-lg flex-shrink-0" data-id="element-461" data-mp="11x1mmjfo5a13">
                      <FileTextIcon className="h-6 w-6 text-blue-800" data-id="element-462" data-mp="16ti9zbf1nkd4" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-463" data-mp="n91d401dosv5">
                      <p className="text-sm font-bold text-gray-900" data-id="element-464" data-mp="i9exxl1zp2jp">
                        {project.brochure.label}
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5" data-id="element-465" data-mp="x80kzgebkkh3">
                        PDF · {project.brochure.note}
                      </p>
                    </div>
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-800 flex-shrink-0" data-id="element-466" data-mp="166c99brpr66d">
                      <DownloadIcon className="h-4 w-4 transition-transform group-hover:translate-y-0.5" data-id="element-467" data-mp="1179f4md9ukd6" />
                      <span className="hidden sm:inline" data-id="element-468" data-mp="1fwdxc3k2gola">View & Download</span>
                    </span>
                  </button>

                  <h4 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2" data-id="element-469" data-mp="1b06r09nrdb2t">
                    <StarIcon className="h-4 w-4 text-blue-800" data-id="element-470" data-mp="1ov90t7vq7kkw" />
                    Key Amenities & Features
                  </h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-471" data-mp="2rbra3iqc4zxb">
                    {project.amenities.map((amenity, idx) => <div key={idx} className="flex items-center gap-3 bg-gray-50 rounded-lg px-4 py-3" data-id="element-472" data-mp="2w87xubtmhc9v" data-mpi={idx}>
                        <CheckCircleIcon className="h-4 w-4 text-blue-800 flex-shrink-0" data-id="element-473" data-mp="359fvcrobe92w" />
                        <span className="text-sm text-gray-700" data-id="element-474" data-mp="28ljcfg5en1oi">{amenity}</span>
                      </div>)}
                  </div>
                </div>}

              {/* Floor Plan Tab */}
              {activeTab === 'floorplan' && <div data-id="element-475" data-mp="2mbmudux94985">
                  <p className="text-gray-600 text-sm mb-4" data-id="element-476" data-mp="2mcwt8mbxhlfu">
                    Typical floor plan for Viral Shantivan — Proposed
                    Redevelopment of Viral & Shantivan Society, Virar West.
                  </p>
                  <div className="rounded-xl overflow-hidden border border-gray-200" data-id="element-477" data-mp="1ttr8e0b29a23">
                    <img src="https://cdn.magicpatterns.com/uploads/nRoW81Yz4fSueuXAws29hU/Screenshot_2026-03-01_102437.png" alt="Typical Floor Plan" className="w-full h-auto" data-id="element-478" data-mp="1marn1p41h8g3" />
                  </div>
                  <div className="mt-4 rounded-xl overflow-hidden border border-gray-200" data-id="element-479" data-mp="18b8krcxwsrbp">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iKY8MrH4rB6iDMRTiYMMsA/WhatsApp_Image_2025-03-15_at_7.40.52_PM.jpg" alt="3D Floor Plan" className="w-full h-auto" data-id="element-480" data-mp="13e8o1smy90x9" />
                  </div>
                </div>}

              {/* Units Tab */}
              {activeTab === 'units' && <div className="space-y-8" data-id="element-481" data-mp="kle92ypbt8t1">
                  {project.wings.map(wing => <div key={wing.name} data-id="element-482" data-mp="foxhfuix4cb7">
                      <h4 className="text-base font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-483" data-mp="fpyxyeipdr0b">
                        <LayersIcon className="h-4 w-4 text-blue-800" data-id="element-484" data-mp="9g6oy5q0j7gk" />
                        {wing.name}
                      </h4>
                      <div className="rounded-xl overflow-hidden border border-gray-200" data-id="element-485" data-mp="4gakk5dele0h">
                        <table className="w-full text-sm" data-id="element-486" data-mp="3vnwm9sgkb6ep">
                          <thead data-id="element-487" data-mp="3vpr59189wog5">
                            <tr className="bg-blue-800 text-white" data-id="element-488" data-mp="3rmbcwh38la99">
                              <th className="text-left px-4 py-3 font-semibold" data-id="element-489" data-mp="3rnmgafsrsfzu">
                                R. No.
                              </th>
                              <th className="text-left px-4 py-3 font-semibold" data-id="element-490" data-mp="3hwrq50cekw94">
                                Type
                              </th>
                              <th className="text-left px-4 py-3 font-semibold" data-id="element-491" data-mp="37xspo51sk6x7">
                                Usable Area
                              </th>
                            </tr>
                          </thead>
                          <tbody data-id="element-492" data-mp="1jey1kmphe8yt">
                            {wing.units.map((unit, idx) => <tr key={idx} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'} data-id="element-493" data-mp="1nf04t0av7ag7" data-mpi={idx}>
                                <td className="px-4 py-3 text-gray-700 font-medium" data-id="element-494" data-mp="1xbl91jf28hiz">
                                  {unit.rno}
                                </td>
                                <td className="px-4 py-3" data-id="element-495" data-mp="14ptgmxraxqn0">
                                  <span className={`inline-block text-xs font-semibold px-2.5 py-1 rounded-full ${unit.type === '2 BHK' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-700'}`} data-id="element-496" data-mp="19nuyjfczrjww">
                                    {unit.type}
                                  </span>
                                </td>
                                <td className="px-4 py-3 text-gray-600" data-id="element-497" data-mp="dxkwyrc642tu">
                                  {unit.area} sq ft
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>)}

                  <div className="bg-blue-50 rounded-xl p-4 text-sm text-blue-800 flex items-start gap-2" data-id="element-498" data-mp="iqw64z4gcvox">
                    <BadgeCheckIcon className="h-4 w-4 flex-shrink-0 mt-0.5" data-id="element-499" data-mp="3r6fv3ly3bry6" />
                    <span data-id="element-500" data-mp="3n4uafefbe9df">
                      <strong data-id="element-501" data-mp="4xemlebrniyw">MahaRERA Registration:</strong> {project.rera} —
                      All unit configurations are as per approved MahaRERA
                      plans.
                    </span>
                  </div>
                </div>}
            </div>

            {/* Modal Footer */}
            <div className="sticky bottom-0 bg-white px-6 py-4 border-t border-gray-100 flex flex-col sm:flex-row gap-3" data-id="element-502" data-mp="1be03qj17u7qo">
              <a href="#contact" onClick={() => setIsModalOpen(false)} className="flex-1 text-center py-3 bg-blue-800 hover:bg-blue-900 text-white rounded-lg font-medium transition-all text-sm" data-id="element-503" data-mp="2ta23t2l2pkts">
                Schedule a Site Visit
              </a>
              <button onClick={() => setIsBrochureOpen(true)} className="flex-1 inline-flex items-center justify-center gap-2 py-3 border border-blue-800 text-blue-800 hover:bg-blue-50 rounded-lg font-medium transition-all text-sm" data-id="element-504" data-mp="2pa1shqt9tpqy">
                <FileTextIcon className="h-4 w-4" data-id="element-505" data-mp="338881qucr31t" />
                View Brochure
              </button>
              <button onClick={() => setIsModalOpen(false)} className="sm:flex-none sm:px-6 py-3 border border-gray-300 hover:bg-gray-50 text-gray-700 rounded-lg font-medium transition-all text-sm" data-id="element-506" data-mp="387ci0jp3p4t7">
                Close
              </button>
            </div>
          </div>
        </div>}

      {/* Brochure Viewer */}
      {isBrochureOpen && <BrochureModal onClose={() => setIsBrochureOpen(false)} data-id="element-507" data-mp="272zr7w1dts9d" />}
    </section>;
};
export default ProjectsSection;